<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr
        :btitle="'Sip User Address'"
        :collapseStatus="'close'"
        style="height: 100%"
      >
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkAdd()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllUserAddr"
                />
                <label for="idSelectAllUserAddr"></label>
              </th>
              <th v-for="(value, key) in title" :key="key" :title="value">
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in uniqueSipUserAddr"
              :key="row.mode"
              :class="{ 'true:': true }"
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectSipUserAddr'"
                  />
                  <label :for="'idRowSelectSipUserAddr'"></label>
                </div>
              </td>
              <td>
                <div>{{ uniqueSipUserAddr[0].mode }}</div>
              </td>
              <td>
                <div>{{ uniqueSipUserAddr[0].vlan }}</div>
              </td>
              <td>
                <div>{{ uniqueSipUserAddr[0].pri }}</div>
              </td>
              <td>
                <div>{{ uniqueSipUserAddr[0].host }}</div>
              </td>
              <td>
                <div>{{ uniqueSipUserAddr[0].ip }}</div>
              </td>
              <td>
                <div>{{ uniqueSipUserAddr[0].mask }}</div>
              </td>
              <td>
                <div>{{ uniqueSipUserAddr[0].gateway }}</div>
              </td>
              <td>
                <div>{{ uniqueSipUserAddr[0].primaryDns }}</div>
              </td>
              <td>
                <div>{{ uniqueSipUserAddr[0].secondaryDns }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Sip User Address Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :scroll="true"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="ipmode">Mode</label>
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="ipmode"
                    v-model="sipUserAddrForm.mode"
                  >
                    <option label="dhcp" value="1"></option>
                    <option label="static" value="0"></option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="vlan">Vlan</label>
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters('vlan', sipUserAddrForm.vlan),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="vlan"
                    v-model="sipUserAddrForm.vlan"
                    placeholder="INTEGER<1-4094>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('vlan', sipUserAddrForm.vlan)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("vlan", sipUserAddrForm.vlan) }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="priority"
                  >Priority</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="priority"
                    v-model="sipUserAddrForm.pri"
                  >
                    <option label="None" value=""></option>
                    <option
                      v-for="p in 8"
                      :key="p"
                      :label="p - 1"
                      :value="p - 1"
                    ></option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="host">Host</label>
                <div class="col-sm-5">
                  <input
                    type="text"
                    class="form-control"
                    id="host"
                    v-model="sipUserAddrForm.host"
                    disabled="true"
                    placeholder="INTEGER<1-4>"
                    autocomplete="off"
                  />
                </div>
              </div>

              <div class="form-group" v-if="sipUserAddrForm.mode == '0'">
                <label class="col-sm-3 control-label" for="ip">IP</label>
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters('ip', sipUserAddrForm.ip),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="ip"
                    v-model="sipUserAddrForm.ip"
                    placeholder="IP adress"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('ip', sipUserAddrForm.ip)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("ip", sipUserAddrForm.ip) }}
                  </small>
                </div>
              </div>
              <div class="form-group" v-if="sipUserAddrForm.mode == '0'">
                <label class="col-sm-3 control-label" for="mask">Mask</label>
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters('ip', sipUserAddrForm.mask),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="mask"
                    v-model="sipUserAddrForm.mask"
                    placeholder="mask"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('ip', sipUserAddrForm.mask)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("ip", sipUserAddrForm.mask) }}
                  </small>
                </div>
              </div>
              <div class="form-group" v-if="sipUserAddrForm.mode == '0'">
                <label class="col-sm-3 control-label" for="gateway"
                  >Gateway</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters('ip', sipUserAddrForm.gateway),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="gateway"
                    v-model="sipUserAddrForm.gateway"
                    placeholder="gateway"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('ip', sipUserAddrForm.gateway)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("ip", sipUserAddrForm.gateway) }}
                  </small>
                </div>
              </div>
              <div class="form-group" v-if="sipUserAddrForm.mode == '0'">
                <label class="col-sm-3 control-label" for="primaryDns"
                  >Primary Dns</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'ip',
                      sipUserAddrForm.primaryDns
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="primaryDns"
                    v-model="sipUserAddrForm.primaryDns"
                    placeholder="master DNS server"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('ip', sipUserAddrForm.primaryDns)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("ip", sipUserAddrForm.primaryDns) }}
                  </small>
                </div>
              </div>
              <div class="form-group" v-if="sipUserAddrForm.mode == '0'">
                <label class="col-sm-3 control-label" for="secondaryDns"
                  >Secondary Dns</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'ip',
                      sipUserAddrForm.secondaryDns
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="secondaryDns"
                    v-model="sipUserAddrForm.secondaryDns"
                    placeholder="slave DNS server"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'ip',
                        sipUserAddrForm.secondaryDns
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("ip", sipUserAddrForm.secondaryDns) }}
                  </small>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  name: "uniqueSipUserAddr",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  props: ["ontIndex"],

  data() {
    return {
      title: "",
      uniqueSipUserAddr: "",
      isShowAddTable: false,
      isSelectAll: false,
      iBox: {},
      sipUserAddrForm: {
        mode: "",
        vlan: "",
        pri: "",
        host: "",
        ip: "",
        mask: "",
        gateway: "",
        primaryDns: "",
        secondaryDns: "",
      },
    }
  },
  created() {
    this.loaduniqueSipUserAddr()
  },

  methods: {
    loaduniqueSipUserAddr() {
      get("uniqueSipUserAddr?ontIndex=" + this.ontIndex)
        .then((res) => {
          this.title = res.data.title
          this.uniqueSipUserAddr = res.data.data
        })
        .catch((err) => {})
    },

    clkAdd() {
      this.isShowAddTable = true
      this.resetField()
      this.selectNull()
    },
    clkEdit() {
      for (let i = 0; i < this.uniqueSipUserAddr.length; i++) {
        if (this.uniqueSipUserAddr[i].selected == true) {
          if (this.uniqueSipUserAddr[0].mode == "dhcp") {
            this.sipUserAddrForm.mode = "1"
          } else {
            this.sipUserAddrForm.mode = "0"
          }
          this.sipUserAddrForm.vlan = this.uniqueSipUserAddr[0].vlan
          this.sipUserAddrForm.pri = this.uniqueSipUserAddr[0].pri
          this.sipUserAddrForm.host = this.uniqueSipUserAddr[0].host
          this.sipUserAddrForm.ip = this.uniqueSipUserAddr[0].ip
          this.sipUserAddrForm.mask = this.uniqueSipUserAddr[0].mask
          this.sipUserAddrForm.gateway = this.uniqueSipUserAddr[0].gateway
          this.sipUserAddrForm.primaryDns = this.uniqueSipUserAddr[0].primaryDns
          this.sipUserAddrForm.secondaryDns =
            this.uniqueSipUserAddr[0].secondaryDns
          this.isShowAddTable = true
        }
      }
    },

    clkDel() {
      var delData = {}

      if (this.uniqueSipUserAddr[0].selected == true) {
        delData["ontIndex"] = this.ontIndex
        post("uniqueSipUserAddrDelete", delData)
          .then((res) => {
            if (
              res.data == undefined ||
              res.data.code === undefined ||
              res.data.code === 0
            ) {
              this.loaduniqueSipUserAddr()
              this.showAlertBox("info", "Info", "Delete Successful!")
            } else this.showAlertBox("warn", "Message", res.data.msg)
          })
          .catch((err) => {
            this.showAlertBox("critical", "error", err)
          })
      }
    },
    clkCancel() {
      this.isShowAddTable = false
    },

    resetField() {
      var sipUserAddrFormTmp = {
        mode: "",
        vlan: "",
        pri: "",
        host: "1",
        ip: "",
        mask: "",
        gateway: "",
        primaryDns: "",
        secondaryDns: "",
      }
      this.sipUserAddrForm = sipUserAddrFormTmp
    },
    changeSelectAll() {
      for (let i = 0; i < this.uniqueSipUserAddr.length; i++) {
        if (this.isSelectAll) {
          this.uniqueSipUserAddr[i].selected = true
        } else {
          this.uniqueSipUserAddr[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.uniqueSipUserAddr.length; i++) {
        this.uniqueSipUserAddr[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var sipUserAddrConfig = {
        ontIndex: this.ontIndex,
        mode: Number(this.sipUserAddrForm.mode),
        vlan: Number(this.sipUserAddrForm.vlan),
        pri: Number(this.sipUserAddrForm.pri),
        host: Number(this.sipUserAddrForm.host),
        ip: this.sipUserAddrForm.ip,
        mask: this.sipUserAddrForm.mask,
        gateway: this.sipUserAddrForm.gateway,
        primaryDns: this.sipUserAddrForm.primaryDns,
        secondaryDns: this.sipUserAddrForm.secondaryDns,
      }

      if (this.sipUserAddrForm.mode == "") {
        this.showAlertBox("warn", "Message", "Invalid mode")
        return
      }

      if (
        this.sipUserAddrForm.mode == "1" &&
        (this.sipUserAddrForm.vlan == "" ||
          this.sipUserAddrForm.host == "" ||
          this.checkParameters("vlan", this.sipUserAddrForm.vlan))
      ) {
        this.showAlertBox("warn", "Message", "Invalid dhcp parameters")
        return
      }
      if (
        this.sipUserAddrForm.mode == "0" &&
        (this.sipUserAddrForm.vlan == "" ||
          this.sipUserAddrForm.host == "" ||
          this.sipUserAddrForm.ip == "" ||
          this.sipUserAddrForm.mask == "" ||
          this.sipUserAddrForm.gateway == "" ||
          this.checkParameters("vlan", this.sipUserAddrForm.vlan) ||
          this.checkParameters("ip", this.sipUserAddrForm.ip) ||
          this.checkParameters("ip", this.sipUserAddrForm.mask) ||
          this.checkParameters("ip", this.sipUserAddrForm.gateway))
      ) {
        this.showAlertBox("warn", "Message", "Invalid static parameters")
        return
      }

      if (this.sipUserAddrForm.pri == "") {
        sipUserAddrConfig.pri = -1
      }

      post("uniqueSipUserAddrConfig", sipUserAddrConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loaduniqueSipUserAddr()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
    },

    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "vlan") {
        if (isNaN(Number(value)) || Number(value) < 1 || Number(value) > 4094) {
          return "vlan must be in range 1-4094"
        }
      } else if (type == "ip") {
        if (
          value.match(/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/) == null
        ) {
          return "the parameter format must be inputted with A.B.C.D"
        } else {
          var id = value.split(".")
          let ip0 = Number(id[0])
          let ip1 = Number(id[1])
          let ip2 = Number(id[2])
          let ip3 = Number(id[3])
          if (
            ip0 < 0 ||
            ip0 > 255 ||
            ip1 < 0 ||
            ip1 > 255 ||
            ip2 < 0 ||
            ip2 > 255 ||
            ip3 < 0 ||
            ip3 > 255 ||
            (ip0 == 0 && ip1 == 0 && ip2 == 0 && ip3 == 0)
          )
            return "invalid value"
        }
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
